<template>
    <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" v-if="!traderData.id" >Add P&L Trader</h5>
              <h5 class="modal-title" v-if="traderData.id" >Edit P&L Trader</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-row">
                        <div class="form-group col-md-6 required ">
                            <label for="inputEmail4">First Name</label>
                            <input  type="text" class="form-control" id="inputEmail4" placeholder="First name" v-model="traderData.firstName"  >
                        </div>
                        <div class="form-group col-md-6">
                            <label for="inputLast">Middle Name</label> 
                            <input type="text" class="form-control" id="inputLast" placeholder="Middle name" v-model="traderData.middleName" >
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 ">
                            <label for="inputLast">Last Name</label>
                            <input type="text" class="form-control" id="inputLast" placeholder="Last name" v-model="traderData.lastName"> 
                        </div> 
                        <div class="form-group col-md-6 required">
                            <label for="inputLast">Trader ID</label>
                            <input type="number" class="form-control" id="inputLast" placeholder="Trader id" v-model.number="traderData.traderId"  > 
                        </div>   
                    </div>
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <p v-if="errors.length">
                        <ul>
                        <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                        </ul>
                    </p>
                    <div class="modal-footer bid">
                        <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                        <button type="button" v-if="!traderData.id" class="btn btn-primary" @click="addTrader()">ADD TRADER</button>
                        <button type="button" v-if="traderData.id" class="btn btn-primary" @click="updateTrader()">UPDATE TRADER</button>
                    </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </template>
    <script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'pltraderadd',
        components :{
            
        },
        props: ['traderData'],
        data() {
            return {
                loading : false,
                errors: []
            };
        },
        methods: {   
            addTrader(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    var addData = {firstName:this.traderData.firstName,middleName:this.traderData.middleName,lastName:this.traderData.lastName,traderId:this.traderData.traderId};
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .post(config.baseUrlBidSide + "/pnl/trader", addData, auth)
                    .then(() => {
                        this.loading = false;              
                        this.$emit('close');               
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            updateTrader(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    var addData = { ...this.traderData};
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .put(config.baseUrlBidSide + "/pnl/trader-update", addData, auth)
                    .then(() => {
                        this.loading = false;              
                        this.$emit('close');               
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            checkForm(){
                this.errors = [];
                if (!this.traderData.firstName) {
                    this.errors.push("First Name is required.");
                    return false;
                }
                if (!this.traderData.traderId) {
                    this.errors.push("Trader Id is required.");
                     return false;
                }
                return true
            }

        }
    };
    </script>